import { Button } from './Button';
import { createSprite } from '../../../utils/GameEngine';

export class ResetButtonRound extends Button {
  private cog: PIXI.Sprite;

  constructor(callback?: () => any, scale: number = 1) {
    super('blue_button_round', callback, null, true, true, scale);
  }

  protected drawLayout(): void {
    super.drawLayout();
    this.cog = createSprite('reset_progress_icon', this);
    this.cog.scale.set(1.5, 1.5);
    this.cog.position.set((this.width - this.cog.width) / 2, (this.height - this.cog.height) / 2 - 2);
  }
}